export function getHotelTrendingListKey(limit: number, sortBy: App.HotelTrendingSortByOptions, exclude: Array<string>, percentile: number) {
  return [sortBy, limit, percentile, ...exclude].join('-')
}
